import { Inventory } from '@/root/shared-types'

export const defaultInventory: Inventory = {
  carDecksAvailabilities: {},
  departureDate: '',
  passengerDecksAvailabilities: {},
}
